<template>
  <div class="input-container">
    <v-card flat>
      <v-card-text>
        <div v-if="!showHospitalProfile">
          <v-row>
            <v-col cols="12" md="2" sm="6">
              <label for class="fz-10px">Search by Name</label>
              <div class="search-div position-relative">
                <input
                  class="form-control"
                  placeholder="Name"
                  v-model="searchParameter.name"
                  @input="debounceSearch(true)"
                />
                <div
                  v-if="searchParameter.name !== ''"
                  class="search-svg position-absolute"
                  @click="clearSearch()"
                >
                  <crossSVG />
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="3" sm="6" class="datepicker pos-r">
              <label for class="d-block-mob fz-10px"
                >Date Range (Joined On)</label
              >
              <datepicker
                v-model="joinOnDateRange"
                @input="dateChange()"
                ref="datepicker"
                :model-config="datePickerConfig"
                :max-date="new Date()"
                is-range
                :masks="{ input: 'DD/MM/YYYY' }"
              >
                <template v-slot="{ inputValue, inputEvents }">
                  <input
                    :value="
                      !!inputValue.start && !!inputValue.end
                        ? inputValue.start + ' - ' + inputValue.end
                        : 'DD/MM/YYYY'
                    "
                    v-on="inputEvents.start"
                    class="form-control position-relative"
                    placeholder="DD/MM/YYYY"
                  />
                  <div
                    v-if="!!inputValue.start && !!inputValue.end"
                    class="cross-svg"
                    @click="resetJoiningDate"
                  >
                    <crossSVG />
                  </div>
                </template>
              </datepicker>
              <div class="calendarsvg userinputcalendar pos-a">
                <calendarSVG />
              </div>
            </v-col>

            <v-col cols="12" md="2" sm="6">
              <div class="position-relative">
                <label for class="fz-12px">Profile</label>
                <select
                  name
                  id
                  class="form-control"
                  v-model="isCompleted"
                  @change="changeProfile()"
                >
                  <option value>All</option>
                  <option value="APPROVED">Approved</option>
                  <option value="PENDING">Pending</option>
                  <option value="REJECT">Rejected</option>
                </select>
                <span class="drop-icon">
                  <i
                    aria-hidden="true"
                    class="
                      v-icon
                      mdi mdi-menu-down
                      theme--light
                      position-absolute
                    "
                  ></i>
                </span>
              </div>
            </v-col>
            <v-col
              v-if="permissions.includes('CAN_EXPORT_HSOPITAL_LISTING')"
              cols="12"
              md="3"
              sm="6"
            >
              <label class="col-sm-12 mb-0 d-none-mob1"></label>
              <v-btn @click="downloadCsv()" class="btn btn-primary"
                >Export</v-btn
              >
            </v-col>
          </v-row>

          <loader v-if="showLoader"></loader>

          <v-row>
            <v-col cols="12" class="mt-2">
              <div class="table-div overflow-auto">
                <table
                  class="table userlistTable table-width small-table-width"
                >
                  <thead>
                    <tr class="table-success">
                      <th scope="col">Hospital Name</th>
                      <th scope="col">Hospital Contact</th>
                      <th scope="col">Owner Name</th>
                      <th scope="col">Owner Contact</th>
                      <th scope="col">Location</th>
                      <th scope="col">Joined On</th>
                      <th
                        scope="col"
                        v-if="role !== 'ambulance'"
                        class="min-width-120"
                      >
                        Verification
                      </th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="table-col-width">
                        <input
                          class="form-control"
                          label="Search by Name"
                          placeholder="Hospital Name"
                          v-model="searchParameter.name"
                          @input="debounceSearch(true)"
                        />
                      </td>
                      <td class="table-col-width">
                        <input
                          class="form-control"
                          label="Search by Number"
                          placeholder="Hospital Contact"
                          v-model="searchParameter.number"
                          @input="debounceSearch(true)"
                        />
                      </td>
                      <td class="table-col-width">
                        <input
                          class="form-control"
                          label="Search by Number"
                          placeholder="Owner Name"
                          v-model="searchParameter.owner_name"
                          @input="debounceSearch(true)"
                        />
                      </td>
                      <td class="table-col-width">
                        <input
                          class="form-control"
                          label="Search by Number"
                          placeholder="Owner Contact"
                          v-model="searchParameter.owner_mobile"
                          @input="debounceSearch(true)"
                        />
                      </td>
                      <td class="table-col-width">
                        <input
                          class="form-control"
                          label="Search by Location"
                          placeholder="Location"
                          v-model="searchParameter.location"
                          @input="debounceSearch(true)"
                        />
                      </td>
                      <td></td>
                      <!-- <td></td> -->
                      <td>
                        <div class="position-relative w-7 table-select">
                          <select
                            name
                            id
                            class="form-control"
                            @change="debounceSearch(true)"
                            v-model="searchParameter.is_verified"
                          >
                            <option value>All</option>
                            <option value="yes">Yes</option>
                            <option value="no">No</option>
                          </select>
                          <span class="drop-icon">
                            <i
                              aria-hidden="true"
                              class="
                                v-icon
                                mdi mdi-menu-down
                                theme--light
                                position-absolute
                              "
                            ></i>
                          </span>
                        </div>
                      </td>
                      <td></td>
                    </tr>
                    <tr v-for="(center, index) in centerList" :key="index">
                      <!-- Centre Name -->
                      <td>
                        <div>{{ center.general && center.general.name }}</div>
                      </td>
                      <!-- Contact No -->
                      <td>
                        <div>{{ center && center.general.contact_number }}</div>
                      </td>
                      <td>
                        <div>
                          {{ center.created_by && center.created_by.full_name }}
                        </div>
                      </td>
                      <td>
                        <div>
                          {{ center.created_by && center.created_by.mobile }}
                        </div>
                      </td>
                      <!-- Location -->
                      <td
                        v-if="
                          center &&
                          center.general.address &&
                          center.general.address.city
                        "
                      >
                        {{ center.general.address.city }}
                      </td>

                      <td>{{ center.created_at | formatDate }}</td>
                      <td>{{ center.reg_status }}</td>
                      <td class="action-div small-table-padding">
                        <div>
                          <CDropdown
                            color="link"
                            size="lg"
                            :caret="false"
                            class="dropdowndocbox"
                          >
                            <template #toggler-content>
                              <verticalDotsSVG />
                            </template>
                            <CDropdownItem v-if="permissions.includes('CAN_VIEW_DETAILS_HOSPITAL_LISTING')" @click="getViewDetails(center)"
                              >View Details</CDropdownItem
                            >
                            <CDropdownItem>Call</CDropdownItem>
                            <CDropdownItem>Message</CDropdownItem>
                            <CDropdownItem @click="clickoutside()"
                              >Email</CDropdownItem
                            >
                            <CDropdownItem>Deactivate</CDropdownItem>
                          </CDropdown>
                        </div>
                      </td>
                    </tr>
                    <tr></tr>
                  </tbody>
                  <tbody v-if="isEmpty">
                    <tr>
                      <td colspan="8">
                        <h2 class="text-center">No Data Found</h2>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </v-col>
          </v-row>

          <div v-if="role === 'ambulance'">
            <p class="mb-0">
              Ambulance address count : {{ totalAmbulanceAddresses }}
            </p>
          </div>
          <pagination
            v-if="!isEmpty"
            class="mx-0 mob-t-center pagination-block"
            :recordPerPage="recordPerPage"
            :total="total"
            @changePage="changePage"
          />
          <div v-if="showPdf">
            <v-dialog v-model="showPdf" width="500" persistent id="view-box">
              <pdf-html
                title="Profile QR"
                subject="shareLink"
                ref="pdfView"
                :identifier="centerId"
                :HideDownloadButton="true"
                :HidePrintButton="true"
                @close="showPdf = false"
                :buttons="[]"
                :queryParameters="urlQueryParam"
                :reCompile="true"
              ></pdf-html>
            </v-dialog>
          </div>
        </div>

        <hospitalProfileSummaryDetails
          v-if="showHospitalProfile"
          @close="closeProfile()"
          :centerId="userId"
        ></hospitalProfileSummaryDetails>
        <image-preview
          @close="closeImageModal"
          v-if="openImageModal"
          :openImageModal="openImageModal"
          :source="fileUrl"
          :fileArcheType="fileArcheType"
        ></image-preview>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import config from "@/config.js";
import formats from "@/formats";
import { pickSvg } from "@/views/SVG";
import InfoIconSVG from "@/views/SVG/InfoIconSVG";
const imagePreview = () => import("@/components/modals/imagePreview.vue");
const pagination = () => import("@/views/common/Pagination");
const loader = () => import("@/components/loader.vue");
import debounce from "lodash/debounce";
import Datepicker from "v-calendar/lib/components/date-picker.umd";
import { mapGetters } from "vuex";
import { bus } from "@/main.js";
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .build();
export default {
  components: {
    hospitalProfileSummaryDetails: () =>
      import(
        "@/views/dashboardNew/userListing/hospitalProfileSummaryDetails.vue"
      ),
    ...pickSvg("messageSVG", "phoneSVG", "emailSVG", "crossSVG"),
    "image-preview": imagePreview,
    pagination,
    InfoIconSVG,
    loader,
    Datepicker,
    PdfHtml: () => import("@/components/PdfHtml"),
  },
  data() {
    return {
      totalAmbulanceAddresses: 0,
      showPdf: false,
      dayJS,
      formats,
      recordPerPage: 10,
      currentPage: 1,
      search: "",
      status: "ALL",
      centerList: [],
      role: "hospital",
      total: "",
      perPageOptions: [
        { perPage: 10, value: 10 },
        { perPage: 20, value: 20 },
        { perPage: 30, value: 30 },
        { perPage: 50, value: 50 },
        { perPage: 100, value: 100 },
      ],
      datePickerConfig: {
        start: {
          timeAdjust: "00:00:00",
        },
        end: {
          timeAdjust: "23:59:59",
        },
      },
      statusOptions: [
        { name: "All", value: "ALL" },
        { name: "Pending", value: "PENDING" },
        { name: "Approved", value: "APPROVED" },
        { name: "Rejected", value: "REJECT" },
        { name: "Not Uploaded", value: "NOT_UPLOADED" },
      ],
      showLoader: false,
      isEmpty: false,
      openImageModal: false,
      fileUrl: "",
      fileArcheType: "",
      centerData: {},
      showCenterApprovalModal: false,
      statusType: "",
      showCenterLogModal: false,
      joinOnDateRange: { start: "", end: "" },
      isCompleted: "",
      showHospitalProfile: false,
      hospitalDetails: {},
      searchParameter: {
        name: "",
        number: "",
        location: "",
        owner_name: "",
        owner_mobile: "",
        is_verified: "",
      },
    };
  },

  computed: {
    ...mapGetters({
      permissions: "getPermissions",
    }),
  },
  mounted() {
    this.debounceSearch();
    this.hospitalDetails = this.$route.params;
    if (this.hospitalDetails){
      // this.role =this.hospitalDetails.role
      this.searchParameter.owner_mobile= this.hospitalDetails.user.mobile
    }
  },

  filters: {
    formatDate: (date) => {
      return dayJS(date).format("DD/MM/YYYY");
    },
  },
  methods: {
    resetJoiningDate() {
      this.joinOnDateRange = { start: "", end: "" };
      this.debounceSearch(true);
    },
    closeProfile() {
      this.showHospitalProfile = false;
    },
    getViewDetails(centerData) {
      this.userId = centerData._id;
      this.showHospitalProfile = true;
    },

    clearSearch() {
      this.searchParameter.name = "";
      this.debounceSearch(true);
    },
    changeProfile() {
      this.debounceSearch(true);
    },
    dateChange() {
      this.debounceSearch(true);
    },
    changePage(page) {
      this.currentPage = page.currentPage;
      this.debounceSearch();
    },
    closeImageModal() {
      this.openImageModal = false;
    },
    verifyCenter(type, centerData) {
      this.centerData = centerData;
      this.showCenterApprovalModal = true;
      this.statusType = type;
    },
    getCenterList() {
      this.showLoader = true;
      let params = {
        page: this.currentPage,
        records_per_page: this.recordPerPage,
        center_name: this.searchParameter.name,
        is_complete: this.isCompleted,
        joined_on_from:
          this.joinOnDateRange.start === ""
            ? ""
            : new Date(this.joinOnDateRange.start).toISOString(),
        joined_on_to:
          this.joinOnDateRange.end === ""
            ? ""
            : new Date(this.joinOnDateRange.end).toISOString(),
        mobile: this.searchParameter.number,
        city: this.searchParameter.location,
        owner_name: this.searchParameter.owner_name,
        owner_mobile: this.searchParameter.owner_mobile,
        is_verified: this.searchParameter.is_verified,
      };

      let url = `${config.BASE_URL}api/v2/admin/center-list/${this.role}`;
      this.$http.get(url, { params }).then((response) => {
        if (response.body.status) {
          this.showLoader = false;
          if (response.body.data.list.length) {
            this.isEmpty = false;
            this.totalAmbulanceAddresses =
              response.body.data.total_ambulance_addresses;
            this.centerList = response.body.data.list;

            this.totalPage = response.body.data.total;
            this.total = response.body.data.count;
          } else {
            this.centerList = [];
            this.isEmpty = true;
          }
        }
      });
    },
    downloadCsv() {
      this.showLoader = true;
      let params = {
        page: this.currentPage,
        records_per_page: this.recordPerPage,
        center_name: this.searchParameter.name,
        is_complete: this.isCompleted,
        joined_on_from:
          this.joinOnDateRange.start === ""
            ? ""
            : new Date(this.joinOnDateRange.start).toISOString(),
        joined_on_to:
          this.joinOnDateRange.end === ""
            ? ""
            : new Date(this.joinOnDateRange.end).toISOString(),
        mobile: this.searchParameter.number,
        city: this.searchParameter.location,
      };
      let url = `${config.BASE_URL}api/v2/admin/center-list-csv/${this.role}`;
      this.$http.get(url, { params }).then((response) => {
        if (response.body.status) {
          this.showLoader = false;
          const data = response.data.data;
          this.download(data.fileName, data.csv);
        }
      });
    },
    download(filename, text) {
      var element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(text)
      );
      element.setAttribute("download", filename);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    },
    debounceSearch: debounce(function (pageReset = false) {
      if (pageReset) {
        bus.$emit("PAGE_CHANGE");
        this.currentPage = 1;
      }

      this.getCenterList();
    }, 500),
  },
};
</script>

<style scoped>
.table-div {
  height: 100vh;
}
</style>